<template>
  <div id="app" class="page-wraper">
    <!-- <HeaderComponent></HeaderComponent> -->
    <router-view />
    <!-- <FooterComponent></FooterComponent> -->
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";

export default {
  name: "HomeView",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (!storedLanguage) {
      localStorage.setItem("language", "en");
    }
  },
};
</script>